/** NHAI-style chainage helpers (aligned with gisavieditor / gisavimvp). */

export function parseChainageMeters(chainage: string): number | null {
  if (!chainage?.trim()) return null;
  const s = chainage.trim();
  const atKm = s.match(/@\s*km\s*([\d.]+)/i) || s.match(/km\s*([\d.]+)/i);
  if (atKm) return parseFloat(atKm[1]) * 1000;
  const normalized = s.replace(/\s+/g, '').toUpperCase().replace(/M$/, '');
  const ch = normalized.match(/^(?:CH)?(\d+)\+(\d+(?:\.\d+)?)$/);
  if (ch) return parseInt(ch[1], 10) * 1000 + parseFloat(ch[2]);
  const num = parseFloat(s);
  if (Number.isFinite(num)) return num >= 1000 ? num : num * 1000;
  return null;
}

export function formatChainageFromMeters(meters: number): string {
  const safe = Math.max(0, Math.round(meters));
  const km = Math.floor(safe / 1000);
  const rem = safe % 1000;
  return `CH ${km}+${rem.toString().padStart(3, '0')}`;
}

export function formatRouteReference(routeCode: string, measureKm: number): string {
  return `${routeCode} @ km ${measureKm.toFixed(3)}`;
}
